<template>
  <v-card class="elevation-0 ma-2">
    <v-card-title class="primary--text">
      Invoice Payment
      <v-divider vertical class="ml-5 mx-0"></v-divider>
    </v-card-title>
    <v-card-actions class="mt-n6">
      <v-form ref="fundForm">
        <v-row class="mx-4 mt-3">
          <v-col md="4">
            <!-- <v-text-field label="Corporate" placeholder="Corporate" outlined dense></v-text-field> -->
            <v-select
              label="Select vendor name *"
              :rules="rules.amount"
              v-model="vendor"
              style="width: 550px"
              :items="vendorlist"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col md="4">
            <v-select
              v-model="paymentMode"
              :rules="rules.amount"
              :items="paymentModeList"
              label="Select Payment Mode"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col md="4">
            <v-text-field
              v-if="paymentMode === 'Glyd Card' || paymentMode === ''"
              v-model="chequenumber"
              color="primary"
              :rules="rules.amount"
              label="Card Number *"
              required
              outlined
              dense
            ></v-text-field>
            <v-text-field
              dense
              v-if="
                paymentMode === 'Bank Account' ||
                paymentMode == 'Cross Border Payment'
              "
              v-model="chequenumber"
              label="Enter Bank Txn ID"
              outlined
              :rules="rules.amount"
              required
            ></v-text-field>
          </v-col>
          <v-col md="4" class="mt-n3">
            <v-text-field
              v-model="amount"
              :rules="rules.amount"
              color="primary"
              label="Amount(RM) *"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col md="4" class="mt-n3">
            <v-dialog
              ref="dialog"
              v-model="modal"
              color="#f4813f"
              :return-value.sync="date_of_transaction"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_of_transaction"
                  dense
                  outlined
                  hint="YYYY/MM/DD"
                  persistent-hint
                  label="Date of Transaction"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :max="new Date().toISOString().substr(0, 10)"
                v-model="date_of_transaction"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text @click="modal = false">Cancel</v-btn>
                <v-btn text @click="$refs.dialog.save(date_of_transaction)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col md="4" class="mt-n3">
            <v-select
              label="Select Bank Name*"
              :items="listOfBankDetails"
              v-model="banknamedetails"
              item-text="name"
              :hint="searchHint"
              item-value="bank_details"
              outlined
              dense
            ></v-select>
          </v-col>
          <!-- <v-col md="2" class="mt-3">
            <v-radio
              v-model="radios"
              label="Select an invoice"
              value="invoice1"
              color="red"
            ></v-radio>
          </v-col>
          <v-col md="3" class="mt-3 ml-n6">
            <v-radio
              v-model="radios"
              color="red"
              label="Upload a new invoice"
              value="invoice2"
            ></v-radio>
          </v-col>
        
          <v-col md="7" class="ml-n16">
            <v-file-input
              outlined
              v-model="file"
              dense
              label="Upload Invoice"
            ></v-file-input>
          </v-col>-->

          <v-row class="ml-6">
            <v-radio-group
              dense
              v-model="radios"
              row
              class="mr-3"
              :mandatory="true"
            >
              <v-radio
                @click="test()"
                label="Select invoice"
                value="invoice1"
                v-model="selectinvoice"
              ></v-radio>
              <v-radio
                @click="test()"
                label="Upload invoice"
                value="invoice2"
                v-model="uploadinvoice"
              ></v-radio>
            </v-radio-group>
            <v-select
              v-if="radios == 0"
              class="mr-6 mt-4"
              label="Select Invoice *"
              :items="listOfBankDetails"
              v-model="banknamedetails"
              outlined
              dense
            ></v-select>
            <v-file-input
              v-if="radios == 1"
              class="mr-6 mt-4"
              outlined
              v-model="file"
              dense
              label="Upload Invoice"
            ></v-file-input>
          </v-row>
          <!-- </v-layout> -->
          <v-col md="12" class="mt-2">
            <v-textarea
              dense
              outlined
              label="Remarks*"
              v-model="comments"
            ></v-textarea>
          </v-col>
          <v-col>
            <v-btn
              class="primary float-right white--text mt-n3 mr-0"
              medium
              :loading="loadingSubmit"
              @click="submitFund()"
            >
              <v-icon class>mdi-plus</v-icon>Submit
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    selectinvoice: "",
    paymentMode: "",
    modal: false,
    date_of_transaction: new Date().toISOString().substr(0, 10),
    listOfBankDetails: [],
    vendorlist: ["Jetha Laal", "Devika Negi"],
    banknamedetails: "",
    vendor: "",
    loadingSubmit: false,
    uploadinvoice: "",
    chequenumber: "",
    comments: "",
    amount: "",
    searchHint: "",
    paymentModeList: ["Glyd Card", "Bank Account", "Cross Border Payment"],
    rules: {
      amount: [(v) => !!v || "Required"],
    },
    radios: "invoice1",
  }),
  created() {},
  methods: {
    test() {
      // alert(20)
      //  console.log("sds", this.radios);
    },
  },
};
</script>
